import { injectable } from "inversify";
import { IIndicadoresGateway } from "../ports/IndicadoresGateway";
import "reflect-metadata";

@injectable()
export default class IndicadoreGatewayAdapter implements IIndicadoresGateway {}
